// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/VintageRumble.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/VintageRumble.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/noise.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Minimal, configurable styles. Colors and some spacing use CSS variables. */

@font-face {
    font-family: "Vintage Rumble";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

:root {
    --bg: #2f2f2f;
    --text: #f5eedc;
    --border: #3a9ba7;
    --primary: #f5a623;
    --radius: 12px;
    --container: 1100px;
    --font-body: "Cooper Black", sans-serif;
    --font-display: "Cooper Black", sans-serif;
    --logo-display: "Vintage Rumble", serif;
}

* {
    box-sizing: border-box;
}
html,
body {
    min-height: 100vh;
}
body {
    margin: 0;
    font-family: var(--font-body);
    color: var(--text);
    background: radial-gradient(
            1200px 600px at 80% -20%,
            rgba(184, 110, 255, 0.75),
            transparent
        ),
        radial-gradient(
            900px 500px at -10% 10%,
            rgba(58, 155, 167, 0.7),
            transparent
        ),
        var(--bg);
    background-attachment: fixed;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
}

#root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
}

a {
    color: var(--primary);
    text-decoration: none;
}
a:hover {
    text-decoration: underline;
}

main {
    flex: 1 1;
}

.container {
    width: 100%;
    max-width: var(--container);
    margin: 0 auto;
    padding: 0 20px;
}

/* Header */
.site-header {
    position: sticky;
    top: 0;
    backdrop-filter: saturate(1.1) blur(6px);
    background: color-mix(in oklab, var(--bg), transparent 30%);
    border-bottom: 1px solid var(--border);
    z-index: 10;
}
.header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 68px;
}
.brand {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: var(--text);
    text-decoration: none;
    font-family: var(--font-display);
    font-weight: 700;
    letter-spacing: 0.3px;
}
.brand img {
    height: 28px;
    width: auto;
}
.nav a {
    color: var(--text);
    text-decoration: none;
    margin-left: 18px;
    letter-spacing: 0.3px;
}
.nav a:hover {
    color: var(--text);
}

/* Hero */
.hero {
    padding: 62px 0;
}
.hero-grid {
    display: grid;
    grid-template-columns: 1.1fr 1fr;
    gap: 40px;
    align-items: center;
}
.lead {
    font-size: 1.125rem;
    color: var(--text);
}
.hero-copy h1 {
    font-size: 2.6rem;
    line-height: 1.1;
    margin: 0 0 14px;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
    font-family: var(--font-display);
}
.hero-copy h1.logo {
    font-size: 3.6rem;
    color: var(--text);
    paint-order: stroke fill;
    text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.35), -1px -1px 0 rgba(0, 0, 0, 0.2);
}
.cta-row {
    display: flex;
    gap: 12px;
    margin-top: 18px;
}

.hero-media {
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: linear-gradient(180deg, color-mix(in oklab, var(--bg), #fff 4%), var(--bg)); */
    /* border: 1px solid var(--border); */
    border-radius: var(--radius);
    padding: 22px;
    position: relative;
    overflow: hidden;
    /* box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset, 0 10px 30px rgba(0,0,0,0.2);  */
    /* border-color: color-mix(in oklab, var(--border), #fff 8%); */
}
.hero-media img {
    width: 100%;
    height: auto;
    border-radius: 10px;
}
.hero-overlay {
    position: absolute;
    inset: 0;
    /* background: radial-gradient(800px 400px at 80% 20%, color-mix(in oklab, var(--bg), transparent 70%), transparent); */
    pointer-events: none;
    mix-blend-mode: screen;
    animation: heroFadeIn 1s ease-out forwards;
    transition: transform 0.2s ease-out;
}

.hero-glow {
    filter: drop-shadow(0 0 12px rgba(255, 138, 0, 0.4));
    animation: heroGlow 5s ease-in-out infinite;
}

/* optional: vignette overlay */
.hero-vignette::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
        circle at center,
        transparent 60%,
        rgba(0, 0, 0, 0.35) 100%
    );
    pointer-events: none;
}

/* optional: soft ground shadow */
.hero-shadow {
    position: absolute;
    bottom: 5%;
    left: 50%;
    width: 70%;
    height: 8%;
    transform: translateX(-50%);
    background: radial-gradient(
        ellipse at center,
        rgba(0, 0, 0, 0.45) 0%,
        transparent 80%
    );
    filter: blur(20px);
}

/* animations */
@keyframes heroFadeIn {
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes heroGlow {
    0%,
    100% {
        filter: drop-shadow(0 0 10px rgba(255, 138, 0, 0.3));
    }
    50% {
        filter: drop-shadow(0 0 25px rgba(255, 138, 0, 0.7));
    }
}

/* parallax-safe */
@media (prefers-reduced-motion: reduce) {
    .hero-img,
    .hero-glow {
        animation: none;
        transform: none;
    }
}

/* Sections */
.section {
    padding: 42px 0;
}
.section-title {
    font-size: 1.6rem;
    margin: 0 0 18px;
    font-family: var(--font-display);
    letter-spacing: 0.5px;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
}
.section-title::after {
    content: "";
    display: block;
    height: 4px;
    width: 72px;
    margin-top: 8px;
    border-radius: 999px;
    background: linear-gradient(
        90deg,
        color-mix(in oklab, var(--primary), #fff 20%),
        var(--primary)
    );
}

/* Features */
.features-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
}
.feature-card {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 18px;
    transition: transform 160ms ease, border-color 160ms ease;
    will-change: transform;
    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,
        0 10px 30px rgba(0, 0, 0, 0.2);
    border-color: color-mix(in oklab, var(--border), #fff 8%);
}
.feature-card h3 {
    margin: 8px 0 6px;
    font-size: 1.05rem;
}
.feature-icon {
    width: 28px;
    height: 28px;
    opacity: 0.9;
    color: #f5a623;
    filter: brightness(0) saturate(100%) invert(74%) sepia(46%) saturate(1326%)
        hue-rotate(341deg) brightness(98%) contrast(95%);
}

/* Signup */
.signup-card {
    background: linear-gradient(
        180deg,
        color-mix(in oklab, var(--bg), #000 10%),
        var(--bg)
    );
    border: 1px solid var(--border);
    border-radius: calc(var(--radius) + 2px);
    padding: 24px;
    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,
        0 10px 30px rgba(0, 0, 0, 0.2);
    border-color: color-mix(in oklab, var(--border), #fff 8%);
}
.signup-form .fields {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}
.signup-form input[type="email"] {
    flex: 1 1;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid var(--border);
    background: #0f1116;
    color: var(--text);
}
.hp {
    position: absolute;
    left: -50000px;
}

.newsletter-checkbox {
    margin-top: 12px;
}

.newsletter-checkbox label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
    color: color-mix(in oklab, var(--text), transparent 20%);
}

.newsletter-checkbox input[type="checkbox"] {
    width: 14px;
    height: 14px;
    cursor: pointer;
    accent-color: var(--text);
}

.success {
    color: var(--text);
    line-height: 0.5;
    text-align: center;
}
.error {
    color: #ff6b6b;
    line-height: 0.5;
    text-align: center;
}

/* Buttons */
.btn {
    appearance: none;
    border: none;
    color: var(--text);
    border: 1px solid var(--border);
    padding: 10px 14px;
    border-radius: 10px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    cursor: pointer;
    background: linear-gradient(
        to bottom,
        color-mix(in oklab, var(--primary), #fff 6%),
        var(--primary)
    );
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.25);
}
.btn:hover {
    border-color: color-mix(in oklab, var(--border), var(--text) 20%);
}
.btn-primary {
    background: var(--primary);
    color: var(--text);
    border-color: transparent;
}
.btn-primary:hover {
    filter: brightness(1.05);
}
.btn-ghost {
    background: linear-gradient(
        to bottom,
        color-mix(in oklab, var(--bg), #fff 3%),
        var(--bg)
    );
    border-color: color-mix(in oklab, var(--border), #fff 10%);
}

/* Footer */
footer {
    margin-top: auto;
    border-top: 1px solid var(--border);
    padding: 32px 0;
}
.footer-inner {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}
.copyright {
    color: var(--text);
    font-size: 0.9rem;
    margin-left: auto;
}
.social a {
    color: var(--text);
    margin-right: 12px;
    text-decoration: none;
}
.social a:hover {
    color: var(--primary);
}

/* Process */
.process-inner {
    display: grid;
    gap: 16px;
}
.process-image-wrap {
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: var(--bg);
    padding: 12px;
    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,
        0 10px 30px rgba(0, 0, 0, 0.2);
    border-color: color-mix(in oklab, var(--border), #fff 8%);
}
.process-image-wrap img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 10px;
}
.process-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 28px;
    margin-top: 6px;
}
.process .step {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: var(--text);
}
.process .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--primary);
    box-shadow: 0 0 0 2px color-mix(in oklab, var(--primary), transparent 40%),
        0 0 0 6px color-mix(in oklab, var(--primary), transparent 85%);
}

/* Retro vibe */
.grain-overlay {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    opacity: 0.06;
    mix-blend-mode: overlay;
}
.vignette-overlay {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    background: radial-gradient(
            1200px 700px at 50% -10%,
            color-mix(in oklab, var(--primary), transparent 80%),
            transparent
        ),
        radial-gradient(
            900px 600px at 100% 0%,
            color-mix(in oklab, var(--text), transparent 85%),
            transparent
        );
}

.text-box {
    background: color-mix(in oklab, var(--bg), transparent 60%);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 18px;
    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,
        0 10px 30px rgba(0, 0, 0, 0.2);
    border-color: color-mix(in oklab, var(--border), #fff 8%);
}

/* Projects Grid */
.projects-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 24px;
    margin-top: 24px;
}
.project-card {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    overflow: hidden;
    transition: transform 160ms ease, border-color 160ms ease;
    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,
        0 10px 30px rgba(0, 0, 0, 0.2);
    border-color: color-mix(in oklab, var(--border), #fff 8%);
}
.project-card:hover {
    transform: translateY(-2px);
    border-color: color-mix(in oklab, var(--border), var(--text) 18%);
}
.project-image {
    width: 100%;
    height: 220px;
    overflow: hidden;
    background: color-mix(in oklab, var(--bg), #000 20%);
}
.project-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.project-content {
    padding: 18px;
}
.project-content h3 {
    margin: 0 0 8px;
    font-size: 1.2rem;
    font-family: var(--font-display);
}
.project-content p {
    color: var(--text);
    margin: 0 0 14px;
    line-height: 1.6;
}

/* Project Detail Page */
.breadcrumb {
    display: inline-block;
    color: var(--text);
    text-decoration: none;
    margin-bottom: 16px;
    font-size: 0.95rem;
}
.breadcrumb:hover {
    color: var(--primary);
}
.project-detail-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    align-items: start;
}
.project-detail-sidebar {
    position: sticky;
    top: 88px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.project-detail-image {
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: var(--bg);
    padding: 12px;
    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,
        0 10px 30px rgba(0, 0, 0, 0.2);
    border-color: color-mix(in oklab, var(--border), #fff 8%);
}
.project-detail-image img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 10px;
}
.project-detail-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.project-detail-content h2 {
    margin: 0 0 12px;
    font-size: 1.2rem;
    font-family: var(--font-display);
}
.feature-list {
    margin: 0;
    padding-left: 24px;
}
.feature-list li {
    margin: 8px 0;
    color: var(--text);
}
.assembly-list {
    margin: 0;
    padding-left: 24px;
    counter-reset: step;
}
.assembly-list li {
    margin: 12px 0;
    color: var(--text);
    position: relative;
}
.specs-list {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px 16px;
    margin: 0;
}
.specs-list dt {
    font-weight: 600;
    color: var(--text);
}
.specs-list dd {
    margin: 0;
    color: var(--text);
}
.files-section {
    margin-top: 32px;
}
.files-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.file-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px;
    background: color-mix(in oklab, var(--bg), #000 20%);
    border-radius: 8px;
    border: 1px solid color-mix(in oklab, var(--border), #fff 5%);
    transition: border-color 160ms ease;
}
.file-item:hover {
    border-color: color-mix(in oklab, var(--border), var(--text) 15%);
}
.file-preview {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;
    background: color-mix(in oklab, var(--bg), #000 30%);
    border: 1px solid var(--border);
}
.file-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.file-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1;
}
.file-name {
    font-weight: 600;
    color: var(--text);
    font-size: 1rem;
}
.component-info {
    font-size: 0.8rem;
    color: var(--text);
}
.btn-sm {
    padding: 8px 16px;
    font-size: 0.9rem;
    flex-shrink: 0;
}

/* Tabs */
.tabs {
    display: flex;
    gap: 8px;
    /* border-bottom: 2px solid color-mix(in oklab, var(--border), transparent 30%); */
    margin-bottom: 24px;
}
.tab-button {
    padding: 12px 24px;
    background: transparent;
    border: none;
    color: var(--text);
    font-family: var(--font-body);
    font-size: 1.6rem;
    font-weight: 600;
    cursor: pointer;
    position: relative;
    transition: all 200ms ease;
    opacity: 0.6;
}
.tab-button:hover {
    opacity: 0.85;
}
.tab-button.active {
    opacity: 1;
    color: var(--primary);
}
.tab-button.active::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 4px;
    width: 72px;
    background: var(--primary);
}
.tab-content {
    padding-top: 8px;
}
.tab-panel h3 {
    margin-top: 0;
    margin-bottom: 16px;
    color: var(--text);
    font-size: 1.3rem;
}
.tab-panel h3:not(:first-child) {
    margin-top: 32px;
}

/* Responsive sidebar */
@media (max-width: 900px) {
    .project-detail-grid {
        grid-template-columns: 1fr;
    }
    .project-detail-image {
        position: static;
    }
}
@media (max-width: 900px) {
    .hero-grid {
        grid-template-columns: 1fr;
    }
}
@media (max-width: 700px) {
    .features-grid {
        grid-template-columns: 1fr;
    }
    .signup-form .fields {
        flex-direction: column;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;IACI,6BAA6B;IAC7B;kEAC6D;IAC7D,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,uCAAuC;IACvC,0CAA0C;IAC1C,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;AAC1B;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB;;;;;;;;;;iBAUa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,MAAM;IACN,wCAAwC;IACxC,2DAA2D;IAC3D,sCAAsC;IACtC,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,wCAAwC;IACxC,gCAAgC;AACpC;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,0EAA0E;AAC9E;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6FAA6F;IAC7F,qCAAqC;IACrC,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,0GAA0G;IAC1G,+DAA+D;AACnE;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,uHAAuH;IACvH,oBAAoB;IACpB,sBAAsB;IACtB,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;IACI,oDAAoD;IACpD,2CAA2C;AAC/C;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;;;KAIC;IACD,oBAAoB;AACxB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,UAAU;IACV,2BAA2B;IAC3B;;;;KAIC;IACD,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI;;QAEI,oDAAoD;IACxD;IACA;QACI,oDAAoD;IACxD;AACJ;;AAEA,kBAAkB;AAClB;IACI;;QAEI,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA,aAAa;AACb;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;IACrB,wCAAwC;AAC5C;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB;;;;KAIC;AACL;;AAEA,aAAa;AACb;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,yDAAyD;IACzD,sBAAsB;IACtB;sCACkC;IAClC,yDAAyD;AAC7D;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd;wDACoD;AACxD;;AAEA,WAAW;AACX;IACI;;;;KAIC;IACD,+BAA+B;IAC/B,wCAAwC;IACxC,aAAa;IACb;sCACkC;IAClC,yDAAyD;AAC7D;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,SAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf;;;;KAIC;IACD,uCAAuC;AAC3C;AACA;IACI,iEAAiE;AACrE;AACA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI;;;;KAIC;IACD,0DAA0D;AAC9D;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb;sCACkC;IAClC,yDAAyD;AAC7D;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B;sEACkE;AACtE;;AAEA,eAAe;AACf;IACI,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV,yDAAyC;IACzC,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV;;;;;;;;;SASK;AACT;;AAEA;IACI,2DAA2D;IAC3D,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb;sCACkC;IAClC,yDAAyD;AAC7D;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;IAChB,yDAAyD;IACzD;sCACkC;IAClC,yDAAyD;AAC7D;AACA;IACI,2BAA2B;IAC3B,iEAAiE;AACrE;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,oDAAoD;AACxD;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb;sCACkC;IAClC,yDAAyD;AAC7D;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,oDAAoD;IACpD,kBAAkB;IAClB,6DAA6D;IAC7D,mCAAmC;AACvC;AACA;IACI,iEAAiE;AACrE;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oDAAoD;IACpD,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;AACX;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,QAAQ;IACR,kFAAkF;IAClF,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["/* Minimal, configurable styles. Colors and some spacing use CSS variables. */\n\n@font-face {\n    font-family: \"Vintage Rumble\";\n    src: url(\"/public/fonts/VintageRumble.woff2\") format(\"woff2\"),\n        url(\"/public/fonts/VintageRumble.ttf\") format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n:root {\n    --bg: #2f2f2f;\n    --text: #f5eedc;\n    --border: #3a9ba7;\n    --primary: #f5a623;\n    --radius: 12px;\n    --container: 1100px;\n    --font-body: \"Cooper Black\", sans-serif;\n    --font-display: \"Cooper Black\", sans-serif;\n    --logo-display: \"Vintage Rumble\", serif;\n}\n\n* {\n    box-sizing: border-box;\n}\nhtml,\nbody {\n    min-height: 100vh;\n}\nbody {\n    margin: 0;\n    font-family: var(--font-body);\n    color: var(--text);\n    background: radial-gradient(\n            1200px 600px at 80% -20%,\n            rgba(184, 110, 255, 0.75),\n            transparent\n        ),\n        radial-gradient(\n            900px 500px at -10% 10%,\n            rgba(58, 155, 167, 0.7),\n            transparent\n        ),\n        var(--bg);\n    background-attachment: fixed;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n}\n\n#root {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    width: 100%;\n}\n\na {\n    color: var(--primary);\n    text-decoration: none;\n}\na:hover {\n    text-decoration: underline;\n}\n\nmain {\n    flex: 1;\n}\n\n.container {\n    width: 100%;\n    max-width: var(--container);\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n/* Header */\n.site-header {\n    position: sticky;\n    top: 0;\n    backdrop-filter: saturate(1.1) blur(6px);\n    background: color-mix(in oklab, var(--bg), transparent 30%);\n    border-bottom: 1px solid var(--border);\n    z-index: 10;\n}\n.header-inner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 68px;\n}\n.brand {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--text);\n    text-decoration: none;\n    font-family: var(--font-display);\n    font-weight: 700;\n    letter-spacing: 0.3px;\n}\n.brand img {\n    height: 28px;\n    width: auto;\n}\n.nav a {\n    color: var(--text);\n    text-decoration: none;\n    margin-left: 18px;\n    letter-spacing: 0.3px;\n}\n.nav a:hover {\n    color: var(--text);\n}\n\n/* Hero */\n.hero {\n    padding: 62px 0;\n}\n.hero-grid {\n    display: grid;\n    grid-template-columns: 1.1fr 1fr;\n    gap: 40px;\n    align-items: center;\n}\n.lead {\n    font-size: 1.125rem;\n    color: var(--text);\n}\n.hero-copy h1 {\n    font-size: 2.6rem;\n    line-height: 1.1;\n    margin: 0 0 14px;\n    letter-spacing: 0.5px;\n    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n    font-family: var(--font-display);\n}\n.hero-copy h1.logo {\n    font-size: 3.6rem;\n    color: var(--text);\n    paint-order: stroke fill;\n    text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.35), -1px -1px 0 rgba(0, 0, 0, 0.2);\n}\n.cta-row {\n    display: flex;\n    gap: 12px;\n    margin-top: 18px;\n}\n\n.hero-media {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* background: linear-gradient(180deg, color-mix(in oklab, var(--bg), #fff 4%), var(--bg)); */\n    /* border: 1px solid var(--border); */\n    border-radius: var(--radius);\n    padding: 22px;\n    position: relative;\n    overflow: hidden;\n    /* box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset, 0 10px 30px rgba(0,0,0,0.2);  */\n    /* border-color: color-mix(in oklab, var(--border), #fff 8%); */\n}\n.hero-media img {\n    width: 100%;\n    height: auto;\n    border-radius: 10px;\n}\n.hero-overlay {\n    position: absolute;\n    inset: 0;\n    /* background: radial-gradient(800px 400px at 80% 20%, color-mix(in oklab, var(--bg), transparent 70%), transparent); */\n    pointer-events: none;\n    mix-blend-mode: screen;\n    animation: heroFadeIn 1s ease-out forwards;\n    transition: transform 0.2s ease-out;\n}\n\n.hero-glow {\n    filter: drop-shadow(0 0 12px rgba(255, 138, 0, 0.4));\n    animation: heroGlow 5s ease-in-out infinite;\n}\n\n/* optional: vignette overlay */\n.hero-vignette::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: radial-gradient(\n        circle at center,\n        transparent 60%,\n        rgba(0, 0, 0, 0.35) 100%\n    );\n    pointer-events: none;\n}\n\n/* optional: soft ground shadow */\n.hero-shadow {\n    position: absolute;\n    bottom: 5%;\n    left: 50%;\n    width: 70%;\n    height: 8%;\n    transform: translateX(-50%);\n    background: radial-gradient(\n        ellipse at center,\n        rgba(0, 0, 0, 0.45) 0%,\n        transparent 80%\n    );\n    filter: blur(20px);\n}\n\n/* animations */\n@keyframes heroFadeIn {\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n@keyframes heroGlow {\n    0%,\n    100% {\n        filter: drop-shadow(0 0 10px rgba(255, 138, 0, 0.3));\n    }\n    50% {\n        filter: drop-shadow(0 0 25px rgba(255, 138, 0, 0.7));\n    }\n}\n\n/* parallax-safe */\n@media (prefers-reduced-motion: reduce) {\n    .hero-img,\n    .hero-glow {\n        animation: none;\n        transform: none;\n    }\n}\n\n/* Sections */\n.section {\n    padding: 42px 0;\n}\n.section-title {\n    font-size: 1.6rem;\n    margin: 0 0 18px;\n    font-family: var(--font-display);\n    letter-spacing: 0.5px;\n    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n}\n.section-title::after {\n    content: \"\";\n    display: block;\n    height: 4px;\n    width: 72px;\n    margin-top: 8px;\n    border-radius: 999px;\n    background: linear-gradient(\n        90deg,\n        color-mix(in oklab, var(--primary), #fff 20%),\n        var(--primary)\n    );\n}\n\n/* Features */\n.features-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 16px;\n}\n.feature-card {\n    background: var(--bg);\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    padding: 18px;\n    transition: transform 160ms ease, border-color 160ms ease;\n    will-change: transform;\n    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,\n        0 10px 30px rgba(0, 0, 0, 0.2);\n    border-color: color-mix(in oklab, var(--border), #fff 8%);\n}\n.feature-card h3 {\n    margin: 8px 0 6px;\n    font-size: 1.05rem;\n}\n.feature-icon {\n    width: 28px;\n    height: 28px;\n    opacity: 0.9;\n    color: #f5a623;\n    filter: brightness(0) saturate(100%) invert(74%) sepia(46%) saturate(1326%)\n        hue-rotate(341deg) brightness(98%) contrast(95%);\n}\n\n/* Signup */\n.signup-card {\n    background: linear-gradient(\n        180deg,\n        color-mix(in oklab, var(--bg), #000 10%),\n        var(--bg)\n    );\n    border: 1px solid var(--border);\n    border-radius: calc(var(--radius) + 2px);\n    padding: 24px;\n    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,\n        0 10px 30px rgba(0, 0, 0, 0.2);\n    border-color: color-mix(in oklab, var(--border), #fff 8%);\n}\n.signup-form .fields {\n    display: flex;\n    gap: 10px;\n    margin-top: 10px;\n}\n.signup-form input[type=\"email\"] {\n    flex: 1;\n    padding: 12px 14px;\n    border-radius: 10px;\n    border: 1px solid var(--border);\n    background: #0f1116;\n    color: var(--text);\n}\n.hp {\n    position: absolute;\n    left: -50000px;\n}\n\n.newsletter-checkbox {\n    margin-top: 12px;\n}\n\n.newsletter-checkbox label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    font-size: 14px;\n    color: color-mix(in oklab, var(--text), transparent 20%);\n}\n\n.newsletter-checkbox input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    cursor: pointer;\n    accent-color: var(--text);\n}\n\n.success {\n    color: var(--text);\n    line-height: 0.5;\n    text-align: center;\n}\n.error {\n    color: #ff6b6b;\n    line-height: 0.5;\n    text-align: center;\n}\n\n/* Buttons */\n.btn {\n    appearance: none;\n    border: none;\n    color: var(--text);\n    border: 1px solid var(--border);\n    padding: 10px 14px;\n    border-radius: 10px;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    cursor: pointer;\n    background: linear-gradient(\n        to bottom,\n        color-mix(in oklab, var(--primary), #fff 6%),\n        var(--primary)\n    );\n    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.25);\n}\n.btn:hover {\n    border-color: color-mix(in oklab, var(--border), var(--text) 20%);\n}\n.btn-primary {\n    background: var(--primary);\n    color: var(--text);\n    border-color: transparent;\n}\n.btn-primary:hover {\n    filter: brightness(1.05);\n}\n.btn-ghost {\n    background: linear-gradient(\n        to bottom,\n        color-mix(in oklab, var(--bg), #fff 3%),\n        var(--bg)\n    );\n    border-color: color-mix(in oklab, var(--border), #fff 10%);\n}\n\n/* Footer */\nfooter {\n    margin-top: auto;\n    border-top: 1px solid var(--border);\n    padding: 32px 0;\n}\n.footer-inner {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n.copyright {\n    color: var(--text);\n    font-size: 0.9rem;\n    margin-left: auto;\n}\n.social a {\n    color: var(--text);\n    margin-right: 12px;\n    text-decoration: none;\n}\n.social a:hover {\n    color: var(--primary);\n}\n\n/* Process */\n.process-inner {\n    display: grid;\n    gap: 16px;\n}\n.process-image-wrap {\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    background: var(--bg);\n    padding: 12px;\n    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,\n        0 10px 30px rgba(0, 0, 0, 0.2);\n    border-color: color-mix(in oklab, var(--border), #fff 8%);\n}\n.process-image-wrap img {\n    width: 100%;\n    height: auto;\n    display: block;\n    border-radius: 10px;\n}\n.process-steps {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 28px;\n    margin-top: 6px;\n}\n.process .step {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--text);\n}\n.process .dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: var(--primary);\n    box-shadow: 0 0 0 2px color-mix(in oklab, var(--primary), transparent 40%),\n        0 0 0 6px color-mix(in oklab, var(--primary), transparent 85%);\n}\n\n/* Retro vibe */\n.grain-overlay {\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 0;\n    background-image: url(\"images/noise.svg\");\n    opacity: 0.06;\n    mix-blend-mode: overlay;\n}\n.vignette-overlay {\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 0;\n    background: radial-gradient(\n            1200px 700px at 50% -10%,\n            color-mix(in oklab, var(--primary), transparent 80%),\n            transparent\n        ),\n        radial-gradient(\n            900px 600px at 100% 0%,\n            color-mix(in oklab, var(--text), transparent 85%),\n            transparent\n        );\n}\n\n.text-box {\n    background: color-mix(in oklab, var(--bg), transparent 60%);\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    padding: 18px;\n    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,\n        0 10px 30px rgba(0, 0, 0, 0.2);\n    border-color: color-mix(in oklab, var(--border), #fff 8%);\n}\n\n/* Projects Grid */\n.projects-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 24px;\n    margin-top: 24px;\n}\n.project-card {\n    background: var(--bg);\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    overflow: hidden;\n    transition: transform 160ms ease, border-color 160ms ease;\n    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,\n        0 10px 30px rgba(0, 0, 0, 0.2);\n    border-color: color-mix(in oklab, var(--border), #fff 8%);\n}\n.project-card:hover {\n    transform: translateY(-2px);\n    border-color: color-mix(in oklab, var(--border), var(--text) 18%);\n}\n.project-image {\n    width: 100%;\n    height: 220px;\n    overflow: hidden;\n    background: color-mix(in oklab, var(--bg), #000 20%);\n}\n.project-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n.project-content {\n    padding: 18px;\n}\n.project-content h3 {\n    margin: 0 0 8px;\n    font-size: 1.2rem;\n    font-family: var(--font-display);\n}\n.project-content p {\n    color: var(--text);\n    margin: 0 0 14px;\n    line-height: 1.6;\n}\n\n/* Project Detail Page */\n.breadcrumb {\n    display: inline-block;\n    color: var(--text);\n    text-decoration: none;\n    margin-bottom: 16px;\n    font-size: 0.95rem;\n}\n.breadcrumb:hover {\n    color: var(--primary);\n}\n.project-detail-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 32px;\n    align-items: start;\n}\n.project-detail-sidebar {\n    position: sticky;\n    top: 88px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n.project-detail-image {\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    background: var(--bg);\n    padding: 12px;\n    box-shadow: 0 1px 0 color-mix(in oklab, var(--border), #fff 20%) inset,\n        0 10px 30px rgba(0, 0, 0, 0.2);\n    border-color: color-mix(in oklab, var(--border), #fff 8%);\n}\n.project-detail-image img {\n    width: 100%;\n    height: auto;\n    display: block;\n    border-radius: 10px;\n}\n.project-detail-content {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n.project-detail-content h2 {\n    margin: 0 0 12px;\n    font-size: 1.2rem;\n    font-family: var(--font-display);\n}\n.feature-list {\n    margin: 0;\n    padding-left: 24px;\n}\n.feature-list li {\n    margin: 8px 0;\n    color: var(--text);\n}\n.assembly-list {\n    margin: 0;\n    padding-left: 24px;\n    counter-reset: step;\n}\n.assembly-list li {\n    margin: 12px 0;\n    color: var(--text);\n    position: relative;\n}\n.specs-list {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    gap: 8px 16px;\n    margin: 0;\n}\n.specs-list dt {\n    font-weight: 600;\n    color: var(--text);\n}\n.specs-list dd {\n    margin: 0;\n    color: var(--text);\n}\n.files-section {\n    margin-top: 32px;\n}\n.files-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n.file-item {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 14px;\n    background: color-mix(in oklab, var(--bg), #000 20%);\n    border-radius: 8px;\n    border: 1px solid color-mix(in oklab, var(--border), #fff 5%);\n    transition: border-color 160ms ease;\n}\n.file-item:hover {\n    border-color: color-mix(in oklab, var(--border), var(--text) 15%);\n}\n.file-preview {\n    width: 80px;\n    height: 80px;\n    flex-shrink: 0;\n    border-radius: 6px;\n    overflow: hidden;\n    background: color-mix(in oklab, var(--bg), #000 30%);\n    border: 1px solid var(--border);\n}\n.file-preview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n.file-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n}\n.file-name {\n    font-weight: 600;\n    color: var(--text);\n    font-size: 1rem;\n}\n.component-info {\n    font-size: 0.8rem;\n    color: var(--text);\n}\n.btn-sm {\n    padding: 8px 16px;\n    font-size: 0.9rem;\n    flex-shrink: 0;\n}\n\n/* Tabs */\n.tabs {\n    display: flex;\n    gap: 8px;\n    /* border-bottom: 2px solid color-mix(in oklab, var(--border), transparent 30%); */\n    margin-bottom: 24px;\n}\n.tab-button {\n    padding: 12px 24px;\n    background: transparent;\n    border: none;\n    color: var(--text);\n    font-family: var(--font-body);\n    font-size: 1.6rem;\n    font-weight: 600;\n    cursor: pointer;\n    position: relative;\n    transition: all 200ms ease;\n    opacity: 0.6;\n}\n.tab-button:hover {\n    opacity: 0.85;\n}\n.tab-button.active {\n    opacity: 1;\n    color: var(--primary);\n}\n.tab-button.active::after {\n    content: \"\";\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    right: 0;\n    height: 4px;\n    width: 72px;\n    background: var(--primary);\n}\n.tab-content {\n    padding-top: 8px;\n}\n.tab-panel h3 {\n    margin-top: 0;\n    margin-bottom: 16px;\n    color: var(--text);\n    font-size: 1.3rem;\n}\n.tab-panel h3:not(:first-child) {\n    margin-top: 32px;\n}\n\n/* Responsive sidebar */\n@media (max-width: 900px) {\n    .project-detail-grid {\n        grid-template-columns: 1fr;\n    }\n    .project-detail-image {\n        position: static;\n    }\n}\n@media (max-width: 900px) {\n    .hero-grid {\n        grid-template-columns: 1fr;\n    }\n}\n@media (max-width: 700px) {\n    .features-grid {\n        grid-template-columns: 1fr;\n    }\n    .signup-form .fields {\n        flex-direction: column;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
